<template>
  <div>
    <div v-html="pageContent"></div>
  </div>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import { onGoToHomeButtonClick } from '@src/js/static-page-script'
export default {
  name: 'CustomError404',
  props: {
    pageContent: { type: String, default: undefined },
  },
  computed: {
    ...authComputed,
    homeRoute() {
      if (this.isPortalLogin) {
        return this.$modules.getModuleRoute('support-portal')
      }
      return this.$modules.getModuleRoute('dashboard')
    },
  },
  mounted() {
    setTimeout(() => {
      onGoToHomeButtonClick().then(() => {
        this.$router.push(this.homeRoute)
      })
    }, 2000)
  },
}
</script>
